// import router from '../../router'
import {
  NS_CHECK, NS_CHECK_SUCCESS, NS_CHECK_FAILURE
} from './mutation-types'

export default {
  state: {
    counter: null
  },
  getters: {
    nsCounter: state => {
      return state.counter
    }
  },
  actions: {
    [NS_CHECK] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/checks'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_CHECK_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_CHECK_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [NS_CHECK_FAILURE] (state, params) {
      console.log('NS_CHECK_FAILURE')
    },
    [NS_CHECK_SUCCESS] (state, data) {
      console.log('NS_CHECK_SUCCESS')
      state.counter = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ns-check.js